import { BlogPostModel } from './../../../core/model/object/blog-model';
import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BlogDataService {
  private user: BlogUserModel;
  private pageNumber: number = 0;
  private blogPostModel: BlogPostModel;
  private scroolToComments: boolean = false;
  private suggests: BlogUserModel[];
  private lastScrollTop: number = 0;
  private latsPostLoaded: number = 0;
  private loadedPost: BlogPostModel[];
  private ProfileScrollStatu: boolean = false;
  private profileLatsPostLoaded: number = 0;
  private profilePostPage: number = 5;
  constructor() {}

  public getUser(): BlogUserModel {
    return this.user;
  }
  public setUser(user: BlogUserModel) {
    this.user = user;
  }

  public getSuggest(): BlogUserModel[] {
    return this.suggests;
  }
  public setSuggest(user: BlogUserModel[]) {
    this.suggests = user;
  }

  public getPost(): BlogPostModel {
    return this.blogPostModel;
  }
  public setPost(Post: BlogPostModel) {
    this.blogPostModel = Post;
  }
  public getPage() {
    return this.pageNumber;
  }
  public setPage(number: number) {
    this.pageNumber = number;
  }
  public getScroolStatus() {
    return this.scroolToComments;
  }
  public setScroolStatus(status: boolean) {
    this.scroolToComments = status;
  }

  public getLastScroll() {
    return this.lastScrollTop;
  }
  public setLastScroll(number: number) {
    this.lastScrollTop = number;
  }

  public getPostLoaded() {
    return this.latsPostLoaded;
  }
  public setPostLoaded(number: number) {
    this.latsPostLoaded = number;
  }
  public getLoadedPost(): BlogPostModel[] {
    return this.loadedPost;
  }
  public setLoadedPost(posts: BlogPostModel[]) {
    this.loadedPost = posts;
  }

  public getProfileScrollStatus() {
    return this.ProfileScrollStatu;
  }
  public setProfileScrollStatus(status: boolean) {
    this.ProfileScrollStatu = status;
  }
  public getProfileLastScroll() {
    return this.profileLatsPostLoaded;
  }
  public setProfileLastScroll(number: number) {
    this.profileLatsPostLoaded = number;
  }

  public getProfilePostPage() {
    return this.profilePostPage;
  }
  public setProfilePostPage(number: number) {
    this.profilePostPage = number;
  }
}
